import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './ContactForm.css';

const Contactform = ({ type = 'text', name, label, value = '', onChange, required = false }) => {
  const [focused, setFocused] = useState(false);

  const handleChange = e => {
    if (onChange) {
      onChange(name, e.target.value);
    }
  };

  return (
    <div className={`input-container ${focused || value ? 'focus' : ''}`}>
      {type === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          className="input"
          value={value}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={handleChange}
          required={required}
          aria-label={label}
          placeholder=" "
        />
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          className="input"
          value={value}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={handleChange}
          required={required}
          aria-label={label}
          autoComplete={name === 'email' ? 'email' : name === 'phone' ? 'tel' : 'on'}
          placeholder=" "
        />
      )}
      <label htmlFor={name}>{label}</label>
      <span>{label}</span>
    </div>
  );
};

Contactform.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

Contactform.defaultProps = {
  type: 'text',
  value: '',
  required: false,
};

export default Contactform;
